// Emergency Services Constants
export const INSTITUTION_TYPES = {
  bomberos: { label: 'Bomberos',  emoji: '🚒', bg: 'bg-red-50',   border: 'border-red-200',  text: 'text-red-700',  activeBg: 'bg-red-600'  },
  hospital: { label: 'Hospital',  emoji: '🏥', bg: 'bg-blue-50',  border: 'border-blue-200', text: 'text-blue-700', activeBg: 'bg-blue-600' },
  policia:  { label: 'Policía',   emoji: '🚔', bg: 'bg-slate-50', border: 'border-slate-200',text: 'text-slate-700',activeBg: 'bg-soem-navy'},
};

export const DEPENDENCY_TYPES = {
  publica:      { label: 'Pública',       bg: 'bg-blue-100 text-blue-800'   },
  privada:      { label: 'Privada',       bg: 'bg-purple-100 text-purple-800'},
  voluntariado: { label: 'Voluntariado',  bg: 'bg-green-100 text-green-800' },
};

export const CARE_LEVELS = {
  '1': { label: 'Nivel 1', desc: 'Prevención y curación básica' },
  '2': { label: 'Nivel 2', desc: 'Diagnóstico y tratamiento especializado' },
  '3': { label: 'Nivel 3', desc: 'Casos complejos y alta tecnología' },
};

// Authorities Constants
export const AGENCY_TYPES = {
  proteccion_civil:  { label: 'Protección Civil',      emoji: '🛡',  bg: 'bg-orange-50', border: 'border-orange-200', text: 'text-orange-700', activeBg: 'bg-orange-600' },
  guardia_nacional:  { label: 'Guardia Nacional',      emoji: '🏛',  bg: 'bg-slate-50',  border: 'border-slate-200',  text: 'text-slate-700',  activeBg: 'bg-soem-navy' },
  secretaria_salud:  { label: 'Secretaría de la Salud',emoji: '🏥',  bg: 'bg-green-50',  border: 'border-green-200',  text: 'text-green-700',  activeBg: 'bg-green-700' },
};

export const JURISDICTION_LEVELS = {
  municipal:     { label: 'Municipal',     desc: 'Autoridad local del municipio' },
  estatal:       { label: 'Estatal',       desc: 'Autoridad del gobierno del estado' },
  federal:       { label: 'Federal',       desc: 'Autoridad del gobierno federal' },
  internacional: { label: 'Internacional', desc: 'Organismo internacional' },
};

export const RANKS = {
  capitan:     { label: 'Capitán'     },
  comisionado: { label: 'Comisionado' },
};
